import { Sidebar } from '@consta/uikit/Sidebar'
import { Delimiter } from '@library/components'
import type { FC } from 'react'

import css from './ProjectSidebar.css'
import { SidebarBottomInfo } from './SidebarBottomInfo'
import { SidebarControls } from './SidebarControls'
import { SidebarHeader } from './SidebarHeader'
import { SidebarTopInfo } from './SidebarTopInfo'
import type { IProjectSidebarTypes } from './types'

export const ProjectSidebar: FC<IProjectSidebarTypes> = ({
  isSidebarOpen,
  closeSidebar,
  projectData,
}) => {
  return (
    <Sidebar
      className={css.projectSidebar}
      size="m"
      isOpen={isSidebarOpen}
      onClickOutside={closeSidebar}
      onEsc={closeSidebar}>
      <Sidebar.Content>
        <SidebarHeader closeSidebar={closeSidebar} projectName={projectData.name} />
        <SidebarTopInfo projectInfo={undefined} />
        <Delimiter position="horizontal" className={css.divider} />
        <SidebarBottomInfo projectData={projectData} />
      </Sidebar.Content>
      <Sidebar.Actions>
        <SidebarControls projectData={projectData} />
      </Sidebar.Actions>
    </Sidebar>
  )
}
